 // rely Alert


var messageLess = {};
import genaration from '../../utils/classname';
export var messageClass = genaration(messageLess, 'message');